import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentDevices: [],
};

export const devicesSlice = createSlice({
  name: "devices",
  initialState,
  reducers: {
    setCurrentDevices: (state, action) => {
      state.currentDevices = action.payload;
    },
    removeCurrentDivice: (state, action) => {
      state.currentDevices = state.currentDevices.filter(
        (device) => device.device_id !== action.payload
      );
    },
  },
});

export const { setCurrentDevices, removeCurrentDivice } = devicesSlice.actions;

export default devicesSlice.reducer;
